module.exports = __webpack_public_path__ + "images/feature/20170214_4-77c31c7c96d876090ed8a96228bd3fad.jpg";